<template>
    <div :class="classes">
        <div v-if="question.type === 'multiple'">
            <input type="checkbox" :name="`answerCheckbox-${question.id}-${index}`"
                   @change="e => chooseAnswer(answer.id, question, e.target.checked)"
                   :checked="selected"
                   :id="`answerCheckbox-${question.id}-${index}`">
            <label :for="`answerCheckbox-${question.id}-${index}`">
                {{ answer.title }}
            </label>
        </div>

        <div v-if="question.type === 'radio'">
            <input type="radio" :name="`answerRadio-${question.id}`" :id="`answerRadio-${question.id}-${index}`"
                   @change="e => chooseAnswer(answer.id, question, e.target.checked)" :checked="selected">
            <label :for="`answerRadio-${question.id}-${index}`">
                {{ answer.title }}
            </label>
        </div>

        <div v-if="question.type === 'file'">
            <input type="checkbox" :name="`imageAnswer-${question.id}`" :id="`customCheck-${question.id}-${index}`"
                   @change="e => chooseAnswer(answer.id, question, e.target.checked)" :checked="selected">
            <label :for="`customCheck-${question.id}-${index}`" class="checkbox-label">
                <a v-if="!isIframe" data-toggle="modal" :data-target="`#imageModal-${question.id}-${index}`">
                    <img :src="answer.file" alt="Answer image"/>
                </a>

              <a v-else :href="answer.file" target="_blank" rel="noreferrer noopener">
                    <img :src="answer.file" alt="Answer image"/>
                </a>
            </label>

            <div v-if="!isIframe" class="modal fade quize-img-modal" :id="`imageModal-${question.id}-${index}`" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <img :src="answer.file" alt="Answer image"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OneAnswer",
    props: ['answer', 'question', 'index', 'selected'],
    computed: {
        classes() {
            let classes = [];

            switch (this.question.type) {
                case 'radio':
                    classes.push('custom-radio-glogal');
                    break;
                case 'multiple':
                    classes.push('custom-checkbox-glogal');
                    break;
                case 'file':
                    classes = classes.concat(['custom-checkbox-glogal', 'checkbox-image', 'custom-checkbox-image']);
                    break;
            }

            return classes;
        },

      isIframe() {
          return window.location.href.search('iframe') !== -1;
      }
    }
}
</script>
